module.exports = __webpack_public_path__ + "static/fonts/iconfont.04438221.eot";